"use strict";

exports.__esModule = true;
exports.findSortedGroupOption = void 0;
var _dateRange = require("./utils/dateRange");
const findSortedGroupOption = (timestamp, option) => {
  switch (option) {
    case "actions.grouping.lastMonth":
      {
        return (0, _dateRange.isAboveMonths)(timestamp, -1, false) && (0, _dateRange.isBelowMonths)(timestamp, 0, true);
      }
    case "actions.grouping.last6Months":
      {
        return (0, _dateRange.isAboveMonths)(timestamp, -6, false) && (0, _dateRange.isBelowMonths)(timestamp, 0, true);
      }
    case "actions.grouping.lastYear":
      {
        return (0, _dateRange.isAboveMonths)(timestamp, -12, false) && (0, _dateRange.isBelowMonths)(timestamp, 0, true);
      }
    case "actions.grouping.last5Year":
      {
        return (0, _dateRange.isAboveMonths)(timestamp, -60, false) && (0, _dateRange.isBelowMonths)(timestamp, 0, true);
      }
    case "actions.grouping.last10Year":
      {
        return (0, _dateRange.isAboveMonths)(timestamp, -120, false) && (0, _dateRange.isBelowMonths)(timestamp, 0, true);
      }
    case "actions.grouping.plus10Year":
      {
        return (0, _dateRange.isBelowMonths)(timestamp, -120, true);
      }
    case "actions.grouping.insurance":
      {
        return typeof timestamp === "string" && timestamp === 'Insurance';
      }
    case "actions.grouping.selfPay":
      {
        return typeof timestamp === "string" && timestamp === 'Self Pay';
      }
    case "actions.grouping.active":
      {
        return (0, _dateRange.isAboveDays)(timestamp, 90, false);
      }
    case "actions.grouping.expires90":
      {
        return (0, _dateRange.isAboveDays)(timestamp, 0, true) && (0, _dateRange.isBelowDays)(timestamp, 90, true);
      }
    case "actions.grouping.expired":
      {
        return (0, _dateRange.isBelowDays)(timestamp, 0, false);
      }
    case "actions.grouping.notApplicable":
      {
        return Number.isNaN(Number.parseInt(timestamp, 10));
      }
    default:
      {
        return false;
      }
  }
};
exports.findSortedGroupOption = findSortedGroupOption;